import { Sparkle } from '@phosphor-icons/react';
import { cn } from '../lib/cn';

export interface BusyProps {
  /** What is happening, visible and announced – "PIN wird geprüft …" */
  label: string;
  /** 'ai': the AI is reading – a sparkle that breathes next to the dots */
  variant?: 'default' | 'ai';
  className?: string;
}

/**
 * Something is on its way (Mike, 24.10.: "Animationen für Ladevorgänge … KI-Verarbeitung"):
 * three calm dots and the words for it. Without motion (reduced motion) the words stay.
 */
export function Busy({ label, variant = 'default', className }: BusyProps) {
  const ai = variant === 'ai';
  return (
    <span
      role="status"
      className={cn(
        'inline-flex items-center gap-gap-sm font-semibold',
        ai ? 'text-accent-secondary' : 'text-text-secondary',
        className,
      )}
    >
      {ai && <Sparkle weight="fill" aria-hidden className="size-icon-md animate-sparkle" />}
      <span aria-hidden className="inline-flex items-end gap-1">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="size-1.5 animate-dot rounded-full bg-current"
            style={{ animationDelay: `${i * 160}ms` }}
          />
        ))}
      </span>
      <span>{label}</span>
    </span>
  );
}
